// jQuery est déjà chargé par WordPress
const $ = window.jQuery;

/**
 * Gestion du header au scroll
 * Ajoute la classe "scrolled" au header quand on dépasse 200px de scroll
 */
const headerScroll = {
    
    // Configuration
    config: {
        scrollThreshold: 200,
        headerSelector: 'header#site-header',
        scrolledClass: 'scrolled'
    },

    // Cache des éléments DOM
    elements: {
        $window: null,
        $header: null
    },

    // État du scroll
    state: {
        isScrolled: false,
        lastScrollTop: 0
    },

    /**
     * Initialisation du composant
     */
    init: function() {
        this.cacheElements();
        this.bindEvents();
        this.checkInitialState();
    },

    /**
     * Mise en cache des éléments DOM
     */
    cacheElements: function() {
        this.elements.$window = $(window);
        this.elements.$header = $(this.config.headerSelector);
    },

    /**
     * Liaison des événements
     */
    bindEvents: function() {
        this.elements.$window.on('scroll', this.throttle(this.handleScroll.bind(this), 16));
        this.elements.$window.on('resize', this.throttle(this.handleResize.bind(this), 250));
    },

    /**
     * Vérification de l'état initial au chargement
     */
    checkInitialState: function() {
        const scrollTop = this.elements.$window.scrollTop();
        this.updateHeaderState(scrollTop);
    },

    /**
     * Gestionnaire de l'événement scroll
     */
    handleScroll: function() {
        const scrollTop = this.elements.$window.scrollTop();
        this.updateHeaderState(scrollTop);
        this.state.lastScrollTop = scrollTop;
    },

    /**
     * Gestionnaire de l'événement resize
     */
    handleResize: function() {
        // Réinitialiser l'état au redimensionnement
        this.checkInitialState();
    },

    /**
     * Mise à jour de l'état du header selon la position de scroll
     * @param {number} scrollTop - Position actuelle du scroll
     */
    updateHeaderState: function(scrollTop) {
        const shouldBeScrolled = scrollTop > this.config.scrollThreshold;

        // Éviter les manipulations DOM inutiles
        if (shouldBeScrolled !== this.state.isScrolled) {
            this.state.isScrolled = shouldBeScrolled;
            
            if (shouldBeScrolled) {
                this.addScrolledClass();
            } else {
                this.removeScrolledClass();
            }
        }
    },

    /**
     * Ajouter la classe scrolled
     */
    addScrolledClass: function() {
        this.elements.$header.addClass(this.config.scrolledClass);
    },

    /**
     * Supprimer la classe scrolled
     */
    removeScrolledClass: function() {
        this.elements.$header.removeClass(this.config.scrolledClass);
    },

    /**
     * Fonction de throttle pour optimiser les performances
     * @param {Function} func - Fonction à throttler
     * @param {number} limit - Limite en millisecondes
     * @return {Function} - Fonction throttlée
     */
    throttle: function(func, limit) {
        let inThrottle;
        return function() {
            const args = arguments;
            const context = this;
            if (!inThrottle) {
                func.apply(context, args);
                inThrottle = true;
                setTimeout(() => inThrottle = false, limit);
            }
        };
    }
};

// Initialisation au chargement du DOM
$(document).ready(function() {
    // Vérifier que le header existe avant d'initialiser
    if ($('header#site-header').length > 0) {
        headerScroll.init();
        console.log('✅ Header scroll component initialized');
    } else {
        console.warn('⚠️ Header element not found, scroll component not initialized');
    }
});

// Export pour pouvoir être utilisé ailleurs si nécessaire
export { headerScroll };
